import React, {useEffect, useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";
import moins from '../../Assets/Icons/moins.svg'
import plus from '../../Assets/Icons/plus.svg'
import check from '../../Assets/Icons/check.svg'

import './ItemPage.scss'
import BaseButton from "../../Components/BaseButton/BaseButton";
import BottomSheet from "../../Components/BottomSheet/BottomSheet";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {ProductModel} from "../../Models/ProductModel";
import {OrderModel, OrderProductModel} from "../../Models/OrderModel";
import {useCreateOrderWithPercentDiscount} from "../../hooks/useCreateOrderWithPercentDiscount";
import {useCreateOrderWithoutDiscount} from "../../hooks/useCreateOrderWithoutDiscount";
import {useGetDiscount} from "../../hooks/useGetDiscount";
import {useCreateOrderWithQuantityDiscount} from "../../hooks/useCreateOrderWithQuantityDiscount";
import {useGetReductionFromQuantity} from "../../hooks/useGetReductionFromQuantity";
import {useGetReductionFromPercentage} from "../../hooks/useGetReductionFromPercentage";
import {useUpdatePanier} from "../../hooks/useUpdatePanier";
import {useUpdateOrderWithoutDiscount} from "../../hooks/useUpdateOrderWithoutDiscount";
import {useUpdateOrderWithPercentDiscount} from "../../hooks/useUpdateOrderWithPercentDiscount";
import {useUpdateOrderWithQuantityDiscount} from "../../hooks/useUpdateOrderWithQuantityDiscount";
import Deposit from "../../Assets/Icons/deposit.svg"
import Error from "../../Components/Error/Error";
import {useModal} from "../../hooks/useModal";
import {useGetStockAvailable} from "../../hooks/useGetStockAvailable";

const ItemPage: React.FC = ({}) => {
    const navigate = useNavigate()

    const product = useSelector<StateModel, ProductModel | undefined>(state => state.productToShow)
    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)
    const [quantitee, setQuantitee] = useState<number>(1)
    const [total, setTotal] = useState<number>(product ? product.priceTTC + product.depositPriceTTC : 0)
    const [showBtmSheet, setShowBtmSheet] = useState<boolean>(false)
    const [showConsigne, setShowConsigne] = useState<boolean>(false)

    const getDiscount = useGetDiscount()
    const discount = getDiscount(product?.automaticDiscounts || [], new Date())
    const updatePanier = useUpdatePanier()
    const updateOrderWithoutDiscount = useUpdateOrderWithoutDiscount()
    const updateOrderWithPercentDiscount = useUpdateOrderWithPercentDiscount()
    const updateOrderWithQuantityDiscount = useUpdateOrderWithQuantityDiscount()
    const createOrderWithPercentDiscount = useCreateOrderWithPercentDiscount()
    const createOrderWithQuantityDiscount = useCreateOrderWithQuantityDiscount()
    const createOrderWithoutDiscount = useCreateOrderWithoutDiscount()
    const [getTotalMinusReductionQuantity, ] = useGetReductionFromQuantity()
    const [getTotalMinusReductionPercent, ] = useGetReductionFromPercentage()

    const modalQuantiteInsufisante = useModal()
    const getStockAvailable = useGetStockAvailable()

    const calculTotal = () => {
        let res = 0
        if (product) {
            if(discount) {
                if(discount.discount.type === "quantity") {
                    res = getTotalMinusReductionQuantity(product.priceTTC * quantitee, product.priceTTC, quantitee, discount, panier?.orderProducts || []) + (product.depositPriceTTC * quantitee)
                } else {
                    res = getTotalMinusReductionPercent(product.priceTTC * quantitee, discount.discount.rate) + (product.depositPriceTTC * quantitee)
                }
            } else {
                res = (product.priceTTC + product.depositPriceTTC) * quantitee
            }
        }
        return res
    }

    useEffect(() => {
        window.scrollTo(0,0);
    }, []);

    useEffect(() => {
        setTotal(calculTotal())
    }, [quantitee])

    const add = () => {
        if(quantitee < getStockAvailable(product)) {
            setQuantitee(quantitee + 1)
        } else {
            modalQuantiteInsufisante.open()
        }
    }

    const remove = () => {
        if(quantitee > 1) {
            setQuantitee(quantitee - 1)
        }
    }

    const handleAddClick = () => {
        const index = panier?.orderProducts?.findIndex(p => p.product.id === product?.product.id)

        if(index !== undefined && index !== -1) {
            updateCartProduct(index)
        } else {
            addToCart()
        }
    }

    const addToCart = () => {
        if(product) {
            const newPanier: OrderModel = panier ? {...panier} : {}
            if(!newPanier.orderProducts) {
                newPanier.orderProducts = []
            }
            let productToPush: OrderProductModel
            const discount = getDiscount(product.automaticDiscounts, new Date())
            if(discount) {
                if(discount.discount.type === "quantity") {
                    productToPush = createOrderWithQuantityDiscount(product, discount, quantitee, newPanier.orderProducts)
                } else {
                    productToPush = createOrderWithPercentDiscount(product, discount, quantitee)
                }
            } else {
                productToPush = createOrderWithoutDiscount(product, quantitee)
            }
            newPanier.orderProducts.push(productToPush)
            updatePanier(newPanier)
            setShowBtmSheet(true)
        }
    }

    const updateCartProduct = (index: number) => {
        const newPanier = {...panier} || {}
        if(!newPanier.orderProducts) {
            newPanier.orderProducts = []
        }
        const itemQuantity = newPanier.orderProducts[index].quantity || 0
        newPanier.orderProducts[index].quantity = itemQuantity + quantitee

        const newOrderProducts: OrderProductModel[] = []

        newPanier.orderProducts.map(p => {return {...p, totalPriceHT: 0, totalPriceTTC: 0, totalTva: 0, discount: 0}}).forEach((p) => {
            if(!p.discountType) {
                newOrderProducts.push(updateOrderWithoutDiscount(p, p.quantity || 0))
            } else if(p.discountType === 'percent') {
                newOrderProducts.push(updateOrderWithPercentDiscount(p, p.quantity || 0))
            } else {
                newOrderProducts.push(updateOrderWithQuantityDiscount(p, p.quantity || 0, newOrderProducts))
            }
        })

        newPanier.orderProducts = newOrderProducts
        updatePanier(newPanier)
        setShowBtmSheet(true)
    }

    return (
        <BasePage showBack showPanier showHistorique>
            {
                product ? (
                    <div className="item">
                        <div className="item__infos">
                            <div className="item__infos__image">
                                <img src={product.product.image} alt={product.product.name}/>
                                {
                                    product?.depositPriceTTC > 0 && (
                                        <div className="item__infos__deposit" onClick={() => setShowConsigne(true)}>
                                            <img src={Deposit} alt="icone consigne"/>
                                            <p>Consigne de {product.depositPriceTTC}€ sur ce produit</p>
                                        </div>
                                    )
                                }
                            </div>
                            <p className="item__infos--name">{product.product.name}</p>
                            {
                                discount && discount.discount.type === 'percent' ? (
                                    <p className="item__infos--prix">{(product.priceTTC - (product.priceTTC * (discount.discount.rate / 100))).toFixed(2)} € <span>{product.priceTTC} €</span></p>
                                ) : (
                                    <p className="item__infos--prix">{product.priceTTC} €</p>
                                )
                            }
                            <p className="item__infos--quantiteeTitle">Quantité</p>
                            <div className="item__infos__quantitee">
                                <img src={moins} alt={"quantitee moins"} className="item__infos__quantitee--moins" onClick={remove} />
                                <p className="item__infos__quantitee--txt">{quantitee}</p>
                                <img src={plus} alt={"quantitee plus"} className="item__infos__quantitee--plus" onClick={add} />
                            </div>
                        </div>
                        <div className="item__footer">
                            <div className="item__footer__infos">
                                <p className="item__footer__infos--total">Total</p>
                                <p className="item__footer__infos--totalTxt">{total.toFixed(2)}€</p>
                            </div>
                            <BaseButton onClick={handleAddClick} text="Ajouter au panier" className="item__footer--btn"/>
                        </div>
                    </div>
                ) : <></>
            }
            <BottomSheet show={showBtmSheet} close={() => setShowBtmSheet(false)}>
               <div className="bottomSheetContent">
                   <img className="bottomSheetContent--img" src={check} alt="check icone" />
                   <p className="bottomSheetContent--title">Article bien ajouté au panier</p>
                   <p className="bottomSheetContent--subTitle">{quantitee > 1 ? `${quantitee} articles` : '1 article'}</p>
                   <div className="bottomSheetContent__btns">
                       <BaseButton onClick={() => navigate(-1)} text="Continuer" className="bottomSheetContent__btns--btn" type="outline"/>
                       <BaseButton onClick={() => navigate('/panier', {state: {fromItemPage: true}})} text="Panier" className="bottomSheetContent__btns--btn"/>
                   </div>
               </div>
            </BottomSheet>
            <Error
                show={showConsigne}
                close={() => setShowConsigne(false)}
                title={`Une consigne de ${product?.depositPriceTTC}€ est appliquée sur le prix de ce produit`}
                subTitle="Rapportez votre gobelet dans les buvettes ouvertes pour récupérer votre consigne"
                btnTxt="Compris"
            />
            <Error
                show={modalQuantiteInsufisante.visible}
                close={modalQuantiteInsufisante.close}
                title={`Quantité insufisante`}
                subTitle="La quantitée demandée dépasse le stock du produit."
                btnTxt="Compris"
            />
        </BasePage>
    )
}

export default ItemPage;
